import React from "react";

export default function CopyStep10() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          10
        </div>
        <h1 className="">
          Após realizar o depósito, digite na pesquisa: <b>MAIA</b>.
        </h1>
      </div>
      <div className="ml-[42px] flex flex-col gap-2.5">
        <p>
          Procure pelo resultado <b>MAIA ™ </b> de <b>@MAIAtrading</b> e clique
          em <b>COPIAR</b>.
        </p>
        <img
          src="https://media.atomicatpages.net/u/0BVrOWOoOHYYehGtCMVYjXF1KZk1/Pictures/6f5kr/n2l5x/BYwvll1725011.jpeg"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
